export const formatStartpageData = rawData => {
  if (!rawData || rawData.length === 0) return null;

  const { Frage, Tasten } = rawData[0];
  return {
    question: Frage,
    buttons: Tasten
      ? Tasten.map(button => ({
          id: button.id,
          text: button.Text,
          number: button.Tastennummer,
        }))
      : [],
  };
};
